import cn from 'clsx';
import { FC } from 'react';
import { isNotEmptyString } from 'common/utils/check-empty-string';
import defaultEstatePhoto from 'assets/images/default_estate_image_SMALL.png';

export const PropertyImage: FC<{ image: string; className?: string }> = ({ image, className }) => {
  const imageClassName = cn('w-full h-full object-cover rounded-lg', className);
  return <img src={isNotEmptyString(image) ? image : defaultEstatePhoto} alt='property' className={imageClassName} />;
};
